import { persist, createJSONStorage } from 'zustand/middleware';
import { _initialState } from './_initialState';
import {
  addNonVisualizedProduct,
  addOutsideProduct,
  addProduct,
  addBundleProducts,
  handleDragEvent,
  loadDesignFromDocument,
  removeNonVisualizedProduct,
  removeProduct,
  resetCart,
  resetDesign,
  resetSelected,
  selectProduct,
  selectVisualizerItem,
  setIsFromPip,
  toggleZoomModal,
  undoProduct,
  updateDesign,
  updateBundles,
  updateNonVisualizedQty
} from './actions';

// Factory function for per-product store
export const createDesignStore = (uniqueId) => persist(
  (set, get) => ({
    ..._initialState,
    uniqueId,
    select: (
      visualizerMetaDataAndChoiceId,
      resetDropZones
    ) => selectProduct(
      set,
      get,
      visualizerMetaDataAndChoiceId,
      resetDropZones
    ),
    selectVisualizerItem: (
      stackItemId,
      resetDropZones
    ) => selectVisualizerItem(
      set,
      get,
      stackItemId,
      resetDropZones
    ),
    loadDesignFromDocument: (dto) => loadDesignFromDocument(set, get, dto),
    resetSelected: () => resetSelected(set, get),
    update: (data) => updateDesign(set, get, data),
    addNonVisualizedProduct: (sku) => addNonVisualizedProduct(set, get, sku),
    removeNonVisualizedProduct: (sku) => removeNonVisualizedProduct(set, get, sku),
    updateNonVisualizedQty: (sku, qty) => updateNonVisualizedQty(set, get, sku, qty),
    add: (
      choiceId, choiceMetaData, origin
    ) => addProduct(
      set,
      get,
      choiceId,
      choiceMetaData,
      origin,
    ),
    setIsFromPip: (
      isFromPip,
    ) => setIsFromPip(
      set,
      get,
      isFromPip,
    ),
    addBundleProducts: (
      metadata, bundleChoiceId, bundleDesign, zone
    ) => addBundleProducts(
      set,
      get,
      metadata,
      bundleChoiceId,
      bundleDesign,
      zone
    ),
    addAccessory: (flag) => addOutsideProduct(set, get, flag),
    remove: (id, bundleId) => removeProduct(set, get, id, bundleId),
    undo: () => undoProduct(set, get),
    reset: () => resetDesign(set, get),
    resetCart: () => resetCart(set, get),
    toggleZoomModal: () => toggleZoomModal(set, get),
    handleDragEvent: (
      isDragging,
      isVisualizerDrag,
    ) => handleDragEvent(set, get, isDragging, isVisualizerDrag),
    resetBundlesAdded: () => set(
      { bundles: {
        ...get().bundles,
        added: _initialState.bundles.added
      } },
      false,
      { type: 'design/resetBundlesAdded' }
    ),
    updateBundles: (data) => updateBundles(set, get, data),
    clearStorage: () => {
      localStorage.removeItem(`design-session-storage-${uniqueId}`);
    },
  }),
  {
    name: `design-session-storage-${uniqueId}`,
    version: 0,
    storage: createJSONStorage(() => localStorage),
    partialize: (state) => ({
      design: {
        ...state.design,
        selectedProduct: null,
        selectedVisualizerItemStackId: null,
        isZoomModalOpen: false,
        dragEvent: { isDragging: false, isVisualizerDrag: false },
        hasAccessories: false,
        isFromPip: false,
      }
    })
  }
);
